import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { EventType, type AuthenticationResult } from '@azure/msal-browser';

import App from './App.tsx';

import { msalInstance } from './config/msalConfig';
import { hasAuthTokens } from './lib/authToken';
import { handleRedirectAuthEvent } from './lib/authRedirectState';

import '@wk/components-react16/dist/all.min.css';
import './index.css';

const isAuthTokenMode = hasAuthTokens();

if (isAuthTokenMode) {
  const fakeAccount = {
    homeAccountId: 'auth-token.account',
    environment: 'login.microsoftonline.com',
    tenantId: '8ac76c91-e7f1-41ff-a89c-3553b2da2c17',
    username: 'auth-token@local',
    localAccountId: 'auth-token.local',
    name: 'Auth Token User',
  };
  msalInstance.getActiveAccount = () => fakeAccount;
  msalInstance.getAllAccounts = () => [fakeAccount];
}

msalInstance.initialize().then(async () => {
  // Default to using the first account if no account is active on page load
  if (
    !isAuthTokenMode &&
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    const account = msalInstance.getAllAccounts()[0];

    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  // Capture redirect failures before InteractiveAuthGate processes the callback.
  msalInstance.addEventCallback((event) => {
    handleRedirectAuthEvent(event);

    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const payload = event.payload as AuthenticationResult;
      if (payload.account) {
        msalInstance.setActiveAccount(payload.account);
      }
    }
  });

  const { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } =
    await import('ag-grid-community');

  ModuleRegistry.registerModules([AllCommunityModule]);
  provideGlobalGridOptions({ theme: 'legacy' });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '') || '/'}>
        <App msalInstance={msalInstance} />
      </BrowserRouter>
    </StrictMode>,
  );
});
